import { z } from 'zod';
import { defineEvents } from '@ndrc/app-sdk/events';
import fr from './messages/fr.json' with { type: 'json' };
export const events = defineEvents({
  'seo_lab.changed': {
    schema: z.object({ id: z.uuid(), kind: z.enum(['snapshot', 'comparison']) }),
    journal: { label: fr.changedEvent, importance: 'normal' },
    realtime: true,
  },
});
